/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Event/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AppointmentBookingStateUpdate from './AppointmentBookingStateUpdate/index'
import ContractSigned from './ContractSigned/index'
import DocumentSigned from './DocumentSigned/index'
import LeadStatusChanged from './LeadStatusChanged/index'
import MedicalFormSubmitted from './MedicalFormSubmitted/index'
import No from './No/index'
import React from 'react'
import ResourceInsert from './ResourceInsert/index'
import TreatmentStatusUpdate from './TreatmentStatusUpdate/index'



/** @type {import('Simple/types.js').View} */
export default function Event({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/ActiveStep/Automation/Event"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedEventTypeValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'event.type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedEventTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AppointmentBookingStateUpdate'}>
<AppointmentBookingStateUpdate
  viewPath={`${viewPath}/AppointmentBookingStateUpdate`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ContractSigned'}>
<ContractSigned
  viewPath={`${viewPath}/ContractSigned`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DocumentSigned'}>
<DocumentSigned
  viewPath={`${viewPath}/DocumentSigned`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'LeadStatusChanged'}>
<LeadStatusChanged
  viewPath={`${viewPath}/LeadStatusChanged`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MedicalFormSubmitted'}>
<MedicalFormSubmitted
  viewPath={`${viewPath}/MedicalFormSubmitted`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResourceInsert'}>
<ResourceInsert
  viewPath={`${viewPath}/ResourceInsert`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentStatusUpdate'}>
<TreatmentStatusUpdate
  viewPath={`${viewPath}/TreatmentStatusUpdate`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}